import { InjectionToken } from '@angular/core';

import { Applicative } from './lazy-load-legacy.model';

export const APPS_ENABLED = new InjectionToken<Applicative[]>('APPS_ENABLED');
export const LOAD_LEGACY = new InjectionToken<string>('LOAD_LEGACY');
